var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterStonesMRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7578 22.9851C47.7578 22.9851 46.9769 27.7208 51.8725 29.2963C51.8725 29.2963 61.3575 32.4428 66.2485 29.2963C66.2485 29.2963 70.2261 27.7208 69.9201 22.9988C69.9201 22.9988 65.6365 21.7384 64.7186 21.7384C63.8007 21.7384 51.5665 22.3686 51.5665 22.3686L47.7578 22.9851Z",
    fill: "#A8A093"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8447 20.7978C48.8447 20.7978 45.6983 23.6292 50.1051 25.8349C50.1051 25.8349 60.4944 28.6662 65.5315 26.4651C65.5315 26.4651 70.5686 24.8896 69.9384 21.428C69.9384 21.428 66.7919 16.706 58.9189 17.9664C58.9189 17.9664 50.7353 17.6513 48.8447 20.7978Z",
    fill: "#D4C9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41983 5.04706C4.41983 5.04706 2.39678 10.7737 8.44767 13.3676C8.44767 13.3676 15.3662 15.9615 20.9879 14.2307C20.9879 14.2307 24.8787 18.9892 33.0942 18.9892C33.9573 18.9892 40.6156 17.0438 41.1773 11.0979L20.1202 9.04293L7.57999 4.28442L4.41527 5.04251L4.41983 5.04706Z",
    fill: "#A8A093"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1786 1.69516C10.1786 1.69516 1.96308 3.42594 4.99081 7.31678C4.99081 7.31678 10.1786 14.6692 22.2895 10.7784C22.2895 10.7784 24.4496 16.4 35.6928 14.2399C35.6928 14.2399 46.0729 12.943 38.2867 6.45823C38.2867 6.45823 31.802 4.29817 28.7742 5.59512C28.7742 5.59512 26.6142 -1.32343 10.1786 1.7043V1.69516Z",
    fill: "#C8BEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.807305 26.5611C0.807305 26.5611 -0.261303 33.0687 6.46089 35.2288C6.46089 35.2288 19.4852 39.5534 26.2119 35.2288C26.2119 35.2288 31.6737 33.0687 31.2536 26.5794C31.2536 26.5794 25.3716 24.8486 24.1112 24.8486C22.8508 24.8486 6.04076 25.7117 6.04076 25.7117L0.807305 26.5566V26.5611Z",
    fill: "#8F897E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30069 23.5562C2.30069 23.5562 -2.02399 27.447 4.03147 30.4748C4.03147 30.4748 18.3024 34.3656 25.221 31.3379C25.221 31.3379 32.1396 29.1778 31.2765 24.4193C31.2765 24.4193 26.9518 17.9346 16.1424 19.6608C16.1424 19.6608 4.89914 19.2269 2.30525 23.5516L2.30069 23.5562Z",
    fill: "#D4C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterStonesMRDefault);
export default __webpack_public_path__ + "static/media/winter_stones_m_r_default.04c003021dde49962d3c67443c616950.svg";
export { ForwardRef as ReactComponent };